import BaseManager from "./BaseManager";

export const postMessageTypes = {
    PMT_GAME_BUSY: 'gameBusy',
    PMT_GAME_NOT_BUSY: 'gameNotBusy',
    PMT_GAME_LOADED: 'gameLoaded',
    PMT_GO_TO_DEPOSIT: 'goToDeposit',
    PMT_CLOSED: 'exit',
    PMT_GAME_RELOAD: 'reloadGame',
};

export const receiveMessageTypes = {
    RMT_PLAY_INTERRUPTED: 'playInterrupted',
    RMT_PLAY_RESUMED: 'playResumed',
    RMT_REFRESH_BALANCE: 'refreshBalance',
    RMT_AUTO_SPIN: 'autospin',
    RMT_STOP_AUTO_SPIN: 'stopAutoSpin',
    RMT_SPIN: 'spin',
    RMT_SHOW_PAY_TABLE: 'showPayTable',
    RMT_SET_MAX_BET: 'maxbet',
};

export default class GameBridgeManager extends BaseManager {
    constructor() {
        super()
    }

    init(adapter) {
        super.init(adapter)
        window.addEventListener('message', this._onMessage.bind(this));
    }

    roundStart(value = 0) {
        this._send(postMessageTypes.PMT_GAME_BUSY);
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
        this._send(postMessageTypes.PMT_GAME_NOT_BUSY);
    }

    goToDeposit() {
        this._send(postMessageTypes.PMT_GO_TO_DEPOSIT);
    }

    gameReload() {
        this._send(postMessageTypes.PMT_GAME_RELOAD);
    }

    closed() {
        this._send(postMessageTypes.PMT_CLOSED);
    }

    _onMessage(event) {
        console.log('::: PostMessageAPI on message', event)
        const message = event.data;

        switch (message.event ? message.event.toLowerCase() : undefined) {
            case receiveMessageTypes.RMT_PLAY_INTERRUPTED.toLowerCase():
                console.log('::: PostMessageAPI freeze')
                this.adapter.freeze && this.adapter.freeze()
                break
            case receiveMessageTypes.RMT_PLAY_RESUMED.toLowerCase():
                console.log('::: PostMessageAPI unfreeze')
                this.adapter.unfreeze && this.adapter.unfreeze()
                break
            case receiveMessageTypes.RMT_REFRESH_BALANCE.toLowerCase():
                console.log('::: PostMessageAPI balance refreshed')
                this.adapter.updateBalance(message.balance)
                break
            case receiveMessageTypes.RMT_AUTO_SPIN.toLowerCase():
                const amount = +message.number_of_rounds;

                if (Number.isNaN(amount)) {
                    console.error('::: Autospins [number_of_rounds] is NaN', message);
                    return;
                }

                this.adapter.startAutoSpins && this.adapter.startAutoSpins(amount)
                break
            case receiveMessageTypes.RMT_STOP_AUTO_SPIN.toLowerCase():
                this.adapter.stopAutospins && this.adapter.stopAutospins()
                break
            case receiveMessageTypes.RMT_SPIN.toLowerCase():
                this.adapter.spin && this.adapter.spin()
                break
            case receiveMessageTypes.RMT_SHOW_PAY_TABLE.toLowerCase():
                this.adapter.togglePaytable()
                break
            case receiveMessageTypes.RMT_SET_MAX_BET.toLowerCase():
                this.adapter.setMaxBet && this.adapter.setMaxBet()
                break
        }
    }

    _send(event) {
        const message = {"event": event};
        window.parent.postMessage(JSON.stringify(message), '*');
        console.log('::: PostMessageAPI sent', message)
    }
}
